<template>
    <v-container fluid class="bg-main">
        <v-layout row>
            <v-flex xs12>

                <v-card>
                    <v-card-title>
                        Orders:
                        <v-spacer></v-spacer>

                        <v-text-field
                                v-model="search"
                                outlined
                                append-icon="search"
                                label="Tìm theo Facebook ID"
                                hide-details
                        ></v-text-field>
                        <div class="float-right div-icon-action">
                            <v-icon @click="print">mdi-printer</v-icon>
                        </div>
                        <div class="float-right div-icon-action ml-0">
                            <export-excel :data="desserts">
                                <v-icon>mdi-file-export</v-icon>
                            </export-excel>
                        </div>
                    </v-card-title>
                    <div id="fb-post-activity-log">
                        <v-data-table
                            :headers="headers"
                            :items="desserts"
                            :options.sync="options"
                            :server-items-length="totalDesserts"
                            :loading="loading"
                            class="elevation-1">
                            
                            <!--fb_id-->
                            <template v-slot:item.fb_id="{item}">
                                <v-layout row>
                                    <a class="a-post-link" :href="item.fb_link" target="_blank">{{ item.fb_id }}</a>
                                </v-layout>
                            </template>

                            <template v-slot:item.type="{item}">
                                {{ item.typeName }}
                            </template>

                            <!--through_hands-->
                            <template v-slot:item.through_hands="{item}">
                                {{ item.throughHandName }}
                            </template>

                            <!--year_account_creation-->
                            <template v-slot:item.year_account_creation="{item}">
                                {{ item.yearAccountCreationName }}
                            </template>

                            <!--note-->
                            <template v-slot:item.note="{item}">
                                {{ item.note }}
                            </template>

                            <!--contact_fb-->
                            <template v-slot:item.contact_fb="{item}">
                                {{ item.contact_fb }}
                            </template>

                            <!--contact_fone-->
                            <template v-slot:item.contact_fone="{item}">
                                {{ item.contact_fone }}
                            </template>

                            <!--status-->
                            <template v-slot:item.status="{item}">
                                {{ item.statusName }}
                            </template>

                            <!--created_at-->
                            <template v-slot:item.created_at="{item}">
                                <v-layout row>
                                    {{ item.created_at }}
                                </v-layout>
                            </template>

                        </v-data-table>
                    </div>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
    import {
        FB_RIP_ACCOUNT_HISTORY
    } from "../../store/actions.type";
    import {baseUrl, centralUrl} from "../../config";

    export default {
        data() {
            return {
                search: '',
                totalDesserts: 0,
                desserts: [],
                loading: true,
                options: {},
                headers: [
                    {text: '#', value: 'id', align: "center"},
                    {text: 'ID FB', value: 'fb_id', align: "center"},
                    {text: 'Loại', value: 'type', align: "center"},
                    {text: 'Qua tay', value: 'through_hands', align: "center"},
                    {text: 'Năm tạo nick', value: 'year_account_creation', align: "center"},
                    {text: 'Ghi chú', value: 'note', align: "center"},
                    {text: 'Thông báo admin', value: 'contact_fb', align: "center"},
                    {text: 'Liên hệ người mua', value: 'contact_fone', align: "center"},
                    {text: 'Ngày mua', value: 'created_at', align: "center"},
                    {text: 'Trạng thái', value: 'status', align: "center"},
                ],
                baseUrl: baseUrl,
                centralUrl: centralUrl,
                typeList: [],
                throughHands: [],
                statusList: [],
            }
        },
        watch: {
            options: {
                handler() {
                    this.getDataFromApi()
                        .then(data => {
                            this.desserts = data.items
                            this.totalDesserts = data.total
                        })
                },
                deep: true,
            },
            search() {
                this.options.page = 1;
                this.getDataFromApi()
                    .then(data => {
                        this.desserts = data.items,
                            this.totalDesserts = data.total
                    });
            }
        },
        created() {
            this.getDataFromApi()
                .then(data => {
                    this.desserts = data.items,
                        this.totalDesserts = data.total
                });
        },
        methods: {
            async getDataFromApi() {
                let data = await this.$store.dispatch(FB_RIP_ACCOUNT_HISTORY);
                
                // history
                this.loading = true
                const { sortBy = [], sortDesc = [], page, itemsPerPage } = this.options

                let items =  data.history;
                const total = items.length

                if (sortBy.length === 1 && sortDesc.length === 1) {
                    items = items.sort((a, b) => {
                        const sortA = a[sortBy[0]]
                        const sortB = b[sortBy[0]]

                        if (sortDesc[0]) {
                            if (sortA < sortB) return 1
                            if (sortA > sortB) return -1
                            return 0
                        } else {
                            if (sortA < sortB) return -1
                            if (sortA > sortB) return 1
                            return 0
                        }
                    })
                }
                if (itemsPerPage > 0) {
                    items = items.slice((page - 1) * itemsPerPage, page * itemsPerPage)
                }

                this.loading = false;
                return {items,total};
            },
            print() {
                this.$htmlToPaper("fb-post-activity-log-print");
            },
        },
    }
</script>
<style lang="scss">
    .div-icon-action {
        i {
            cursor: pointer;
        }
    }

    .a-post-link {
        text-decoration: none;
    }

    #fb-post-activity-log-print {
        display: none;
    }
</style>
